import { render, staticRenderFns } from "./orderDetailProduct2.vue?vue&type=template&id=8a88e124"
import script from "./orderDetailProduct2.vue?vue&type=script&lang=js"
export * from "./orderDetailProduct2.vue?vue&type=script&lang=js"
import style0 from "./orderDetailProduct2.vue?vue&type=style&index=0&id=8a88e124&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8a88e124')) {
      api.createRecord('8a88e124', component.options)
    } else {
      api.reload('8a88e124', component.options)
    }
    module.hot.accept("./orderDetailProduct2.vue?vue&type=template&id=8a88e124", function () {
      api.rerender('8a88e124', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/order/components/orderDetailProduct2.vue"
export default component.exports